import { Switch, message } from "antd"
import { translations } from "../../Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const { common_error_msg } = translations[lang]
export const productActions = (
  handleDeleteProductModalOpen,
  handleDeleteProductConfirmation,
  handleEditProduct,
  handleUpdateProduct,
  updateLoading,
  lang,
  product
) => {
  return [
    {
      switch: (row) => (
        <>
          <Switch
            checked={row.is_active}
            className="custom-switch mr-20"
            disabled={updateLoading[row.id]} // Disable switch when updating
            onChange={(status) => {
              if (!updateLoading[row.id]) {
                handleUpdateProduct("", "", row, status)
                message.warning(
                  common_error_msg?.wait_while_product_uploading,
                  4
                )
              }
            }}
          />
        </>
      ),
      type: "switch",
    },
    {
      icon: "/store/editStore.svg",
      className: "edit",
      onClick: (row) => handleEditProduct(row),
      type: "image",
    },
    {
      icon: "/store/trash.svg",
      className: "delete",
      onClick: (row) => {
        handleDeleteProductModalOpen(row)
      },
      type: "image",
    },
  ]
}
